// extracted by mini-css-extract-plugin
export default {"root":"BreadCrumb_root__wPOpg","underlineText":"BreadCrumb_underlineText__9Vxq+","breadCrumbsPath":"BreadCrumb_breadCrumbsPath__7CAeh"};